export default __webpack_public_path__ + "static/media/2d.d7203fb0.svg";